import { SLOTS } from './slots.js'

// Places scoped to a college town (area). Paginated + filtered server-side. Active is
// an in-table toggle (the canonical way an on/off state renders); pages pass onToggle.
// Display values (point source label) come formatted from the server.
export default {
  key: 'place',
  label: 'Place',
  icon: 'places',
  columns: [
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    { slot: SLOTS.METADATA, field: 'phone', label: 'Phone', nowrap: true },
    { slot: SLOTS.METADATA, field: 'address', label: 'Address' },
    { slot: SLOTS.METADATA, field: 'point_source.label', label: 'Point Source', link: 'point_source.url' },
    { slot: SLOTS.METADATA, field: 'official_partner', label: 'Partner', renderer: 'boolean', trueLabel: 'Partner', falseLabel: 'Not a partner', align: 'center' },
    { slot: SLOTS.METADATA, field: 'checkin_enabled', label: 'Check-in', renderer: 'boolean', trueLabel: 'Enabled', falseLabel: 'Disabled', align: 'center' },
    { slot: SLOTS.METADATA, field: 'schedule', label: 'Schedule', renderer: 'schedule' }
  ],
  empty: { icon: 'places', message: 'No places found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY] }
}
